import { type FC } from 'react';
import { Link } from 'react-router-dom';

import { ChangesStatus } from '@editor2/types/changesStatus';
import { DeletedBadge, NewBadge } from '../../Badge';

interface Props {
	changesStatuses: ChangesStatus[];
	headerTitle: string;
	link?: string;
}

const ChangesHeader: FC<Props> = (props) => {
	const { changesStatuses, headerTitle, link } = props;

	return (
		<div className="changeHeader">
			{link ? (
				<Link to={link} className="headerTitle link">
					{headerTitle}
				</Link>
			) : (
				<span className="headerTitle">{headerTitle}</span>
			)}

			{changesStatuses.includes(ChangesStatus.New) && <NewBadge />}
			{changesStatuses.includes(ChangesStatus.Deleted) && <DeletedBadge />}
		</div>
	);
};

export default ChangesHeader;
